var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcSevervations = function SvgIcSevervations(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141103",
    d: "M15.833 2.5V.833a.833.833 0 1 0-1.666 0V2.5h1.666zM5.833 2.5V.833a.833.833 0 1 0-1.666 0V2.5h1.666zM17.5 19.167h-15a2.5 2.5 0 0 1-2.5-2.5V5.833a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v10.834a2.5 2.5 0 0 1-2.5 2.5zM18.333 7.5H1.667v9.167c0 .46.373.833.833.833h15c.46 0 .833-.373.833-.833V7.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 3.333,
    y: 9.167,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 8.333,
    y: 9.167,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 3.333,
    y: 13.333,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 8.333,
    y: 13.333,
    fill: "#F8D822",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 2.5,
    x: 13.333,
    y: 9.167,
    fill: "#F8D822",
    rx: 0.5
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSevervations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-severvations.b1a42db2.svg";
export { ForwardRef as ReactComponent };